import React from 'react';

interface IAppContext {
  userCountry: { countryCode: string; coordinates: number[] };
}

const DEFAULT_USER_COUNTRY = {
  countryCode: 'AU',
  coordinates: [] as number[],
};

const AppContext = React.createContext<IAppContext>({
  userCountry: DEFAULT_USER_COUNTRY,
});

const AppContextProvider: React.FC<React.PropsWithChildren<any>> = (props) => {
  return (
    <AppContext.Provider value={{ userCountry: DEFAULT_USER_COUNTRY }} {...props} />
  );
};

function useAppContext() {
  const ctx = React.useContext(AppContext);
  return ctx;
}

export { AppContextProvider, useAppContext };
